<template>
  <div class="container">
    <Breadcrumbs :items="breadcrumbs" />
    <section class="my-24">
      <FormLogin class="m-auto" @success="onFormLoginSuccess">
        <template v-if="innerHasReset" #subtitle>
          <ClientOnly>
            <MessageBox :show="true" class="mb-12">
              <p class="text-lg" role="alert">
                Riesegui l'accesso all'Area Riservata utilizzando le nuove
                credenziali.
              </p>
            </MessageBox>
          </ClientOnly>
        </template>
      </FormLogin>
    </section>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import Breadcrumbs from '~/components/Breadcrumbs.vue'
import FormLogin from '~/components/FormLogin.vue'
import MessageBox from '~/components/MessageBox.vue'

export default {
  components: {
    Breadcrumbs,
    FormLogin,
    MessageBox,
  },
  middleware: 'legacy-guest',
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Login',
        },
      ],
      innerHasReset: false,
      innerHasRenewed: false,
    }
  },
  computed: {
    ...mapState('interactions', ['hasReset']),
  },
  mounted() {
    if (this.hasReset) {
      this.innerHasReset = true
      this.setHasReset(false)
    }
    if (this.hasRenewed) {
      this.innerHasRenewed = true
      this.setHasRenewed(false)
    }
  },
  methods: {
    ...mapMutations('interactions', ['setHasReset', 'setHasRenewed']),
    onFormLoginSuccess() {
      this.$router.push('/area-riservata/dashboard')
    },
  },
}
</script>
